"use strict";
/*
 * This code was generated by
 * ___ _ _ _ _ _    _ ____    ____ ____ _    ____ ____ _  _ ____ ____ ____ ___ __   __
 *  |  | | | | |    | |  | __ |  | |__| | __ | __ |___ |\ | |___ |__/ |__|  | |  | |__/
 *  |  |_|_| | |___ | |__|    |__| |  | |    |__] |___ | \| |___ |  \ |  |  | |__| |  \
 *
 * Twilio - Notify
 * This is the public Twilio REST API.
 *
 * NOTE: This class is auto generated by OpenAPI Generator.
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicePage = exports.ServiceInstance = exports.ServiceContextImpl = void 0;
exports.ServiceListInstance = ServiceListInstance;
const util_1 = require("util");
const Page_1 = __importDefault(require("../../../base/Page"));
const deserialize = require("../../../base/deserialize");
const serialize = require("../../../base/serialize");
const utility_1 = require("../../../base/utility");
const binding_1 = require("./service/binding");
const notification_1 = require("./service/notification");
class ServiceContextImpl {
    constructor(_version, sid) {
        this._version = _version;
        if (!(0, utility_1.isValidPathParam)(sid)) {
            throw new Error("Parameter 'sid' is not valid.");
        }
        this._solution = { sid };
        this._uri = `/Services/${sid}`;
    }
    get bindings() {
        this._bindings =
            this._bindings || (0, binding_1.BindingListInstance)(this._version, this._solution.sid);
        return this._bindings;
    }
    get notifications() {
        this._notifications =
            this._notifications ||
                (0, notification_1.NotificationListInstance)(this._version, this._solution.sid);
        return this._notifications;
    }
    remove(callback) {
        const headers = {};
        const instance = this;
        let operationVersion = instance._version, operationPromise = operationVersion.remove({
            uri: instance._uri,
            method: "delete",
            headers,
        });
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    removeWithHttpInfo(callback) {
        const headers = {};
        const instance = this;
        let operationVersion = instance._version;
        // DELETE operation - returns boolean based on status code
        let operationPromise = operationVersion
            .removeWithResponseInfo({ uri: instance._uri, method: "delete", headers })
            .then((response) => ({
            ...response,
            body: response.statusCode === 204,
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    fetch(callback) {
        const headers = {};
        headers["Accept"] = "application/json";
        const instance = this;
        let operationVersion = instance._version, operationPromise = operationVersion.fetch({
            uri: instance._uri,
            method: "get",
            headers,
        });
        operationPromise = operationPromise.then((payload) => new ServiceInstance(operationVersion, payload, instance._solution.sid));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    fetchWithHttpInfo(callback) {
        const headers = {};
        headers["Accept"] = "application/json";
        const instance = this;
        let operationVersion = instance._version;
        // CREATE, FETCH, UPDATE operations
        let operationPromise = operationVersion
            .fetchWithResponseInfo({
            uri: instance._uri,
            method: "get",
            headers,
        })
            .then((response) => ({
            ...response,
            body: new ServiceInstance(operationVersion, response.body, instance._solution.sid),
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    update(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["apnCredentialSid"] !== undefined)
            data["ApnCredentialSid"] = params["apnCredentialSid"];
        if (params["gcmCredentialSid"] !== undefined)
            data["GcmCredentialSid"] = params["gcmCredentialSid"];
        if (params["messagingServiceSid"] !== undefined)
            data["MessagingServiceSid"] = params["messagingServiceSid"];
        if (params["facebookMessengerPageId"] !== undefined)
            data["FacebookMessengerPageId"] = params["facebookMessengerPageId"];
        if (params["defaultApnNotificationProtocolVersion"] !== undefined)
            data["DefaultApnNotificationProtocolVersion"] =
                params["defaultApnNotificationProtocolVersion"];
        if (params["defaultGcmNotificationProtocolVersion"] !== undefined)
            data["DefaultGcmNotificationProtocolVersion"] =
                params["defaultGcmNotificationProtocolVersion"];
        if (params["fcmCredentialSid"] !== undefined)
            data["FcmCredentialSid"] = params["fcmCredentialSid"];
        if (params["defaultFcmNotificationProtocolVersion"] !== undefined)
            data["DefaultFcmNotificationProtocolVersion"] =
                params["defaultFcmNotificationProtocolVersion"];
        if (params["logEnabled"] !== undefined)
            data["LogEnabled"] = serialize.bool(params["logEnabled"]);
        if (params["alexaSkillId"] !== undefined)
            data["AlexaSkillId"] = params["alexaSkillId"];
        if (params["defaultAlexaNotificationProtocolVersion"] !== undefined)
            data["DefaultAlexaNotificationProtocolVersion"] =
                params["defaultAlexaNotificationProtocolVersion"];
        if (params["deliveryCallbackUrl"] !== undefined)
            data["DeliveryCallbackUrl"] = params["deliveryCallbackUrl"];
        if (params["deliveryCallbackEnabled"] !== undefined)
            data["DeliveryCallbackEnabled"] = serialize.bool(params["deliveryCallbackEnabled"]);
        const headers = {};
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        headers["Accept"] = "application/json";
        const instance = this;
        let operationVersion = instance._version, operationPromise = operationVersion.update({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        });
        operationPromise = operationPromise.then((payload) => new ServiceInstance(operationVersion, payload, instance._solution.sid));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    updateWithHttpInfo(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["apnCredentialSid"] !== undefined)
            data["ApnCredentialSid"] = params["apnCredentialSid"];
        if (params["gcmCredentialSid"] !== undefined)
            data["GcmCredentialSid"] = params["gcmCredentialSid"];
        if (params["messagingServiceSid"] !== undefined)
            data["MessagingServiceSid"] = params["messagingServiceSid"];
        if (params["facebookMessengerPageId"] !== undefined)
            data["FacebookMessengerPageId"] = params["facebookMessengerPageId"];
        if (params["defaultApnNotificationProtocolVersion"] !== undefined)
            data["DefaultApnNotificationProtocolVersion"] =
                params["defaultApnNotificationProtocolVersion"];
        if (params["defaultGcmNotificationProtocolVersion"] !== undefined)
            data["DefaultGcmNotificationProtocolVersion"] =
                params["defaultGcmNotificationProtocolVersion"];
        if (params["fcmCredentialSid"] !== undefined)
            data["FcmCredentialSid"] = params["fcmCredentialSid"];
        if (params["defaultFcmNotificationProtocolVersion"] !== undefined)
            data["DefaultFcmNotificationProtocolVersion"] =
                params["defaultFcmNotificationProtocolVersion"];
        if (params["logEnabled"] !== undefined)
            data["LogEnabled"] = serialize.bool(params["logEnabled"]);
        if (params["alexaSkillId"] !== undefined)
            data["AlexaSkillId"] = params["alexaSkillId"];
        if (params["defaultAlexaNotificationProtocolVersion"] !== undefined)
            data["DefaultAlexaNotificationProtocolVersion"] =
                params["defaultAlexaNotificationProtocolVersion"];
        if (params["deliveryCallbackUrl"] !== undefined)
            data["DeliveryCallbackUrl"] = params["deliveryCallbackUrl"];
        if (params["deliveryCallbackEnabled"] !== undefined)
            data["DeliveryCallbackEnabled"] = serialize.bool(params["deliveryCallbackEnabled"]);
        const headers = {};
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        headers["Accept"] = "application/json";
        const instance = this;
        let operationVersion = instance._version;
        // CREATE, FETCH, UPDATE operations
        let operationPromise = operationVersion
            .updateWithResponseInfo({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        })
            .then((response) => ({
            ...response,
            body: new ServiceInstance(operationVersion, response.body, instance._solution.sid),
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    }
    /**
     * Provide a user-friendly representation
     *
     * @returns Object
     */
    toJSON() {
        return this._solution;
    }
    [util_1.inspect.custom](_depth, options) {
        return (0, util_1.inspect)(this.toJSON(), options);
    }
}
exports.ServiceContextImpl = ServiceContextImpl;
class ServiceInstance {
    constructor(_version, payload, sid) {
        this._version = _version;
        this.sid = payload.sid;
        this.accountSid = payload.account_sid;
        this.friendlyName = payload.friendly_name;
        this.dateCreated = deserialize.iso8601DateTime(payload.date_created);
        this.dateUpdated = deserialize.iso8601DateTime(payload.date_updated);
        this.apnCredentialSid = payload.apn_credential_sid;
        this.gcmCredentialSid = payload.gcm_credential_sid;
        this.fcmCredentialSid = payload.fcm_credential_sid;
        this.messagingServiceSid = payload.messaging_service_sid;
        this.facebookMessengerPageId = payload.facebook_messenger_page_id;
        this.defaultApnNotificationProtocolVersion =
            payload.default_apn_notification_protocol_version;
        this.defaultGcmNotificationProtocolVersion =
            payload.default_gcm_notification_protocol_version;
        this.defaultFcmNotificationProtocolVersion =
            payload.default_fcm_notification_protocol_version;
        this.logEnabled = payload.log_enabled;
        this.url = payload.url;
        this.links = payload.links;
        this.alexaSkillId = payload.alexa_skill_id;
        this.defaultAlexaNotificationProtocolVersion =
            payload.default_alexa_notification_protocol_version;
        this.deliveryCallbackUrl = payload.delivery_callback_url;
        this.deliveryCallbackEnabled = payload.delivery_callback_enabled;
        this._solution = { sid: sid || this.sid };
    }
    get _proxy() {
        this._context =
            this._context ||
                new ServiceContextImpl(this._version, this._solution.sid);
        return this._context;
    }
    /**
     * Remove a ServiceInstance
     *
     * @param callback - Callback to handle processed record
     *
     * @returns Resolves to processed boolean
     */
    remove(callback) {
        return this._proxy.remove(callback);
    }
    /**
     * Remove a ServiceInstance and return HTTP info
     *
     * @param callback - Callback to handle processed record
     *
     * @returns Resolves to processed boolean with HTTP metadata
     */
    removeWithHttpInfo(callback) {
        return this._proxy.removeWithHttpInfo(callback);
    }
    /**
     * Fetch a ServiceInstance
     *
     * @param callback - Callback to handle processed record
     *
     * @returns Resolves to processed ServiceInstance
     */
    fetch(callback) {
        return this._proxy.fetch(callback);
    }
    /**
     * Fetch a ServiceInstance and return HTTP info
     *
     * @param callback - Callback to handle processed record
     *
     * @returns Resolves to processed ServiceInstance with HTTP metadata
     */
    fetchWithHttpInfo(callback) {
        return this._proxy.fetchWithHttpInfo(callback);
    }
    update(params, callback) {
        return this._proxy.update(params, callback);
    }
    updateWithHttpInfo(params, callback) {
        return this._proxy.updateWithHttpInfo(params, callback);
    }
    /**
     * Access the bindings.
     */
    bindings() {
        return this._proxy.bindings;
    }
    /**
     * Access the notifications.
     */
    notifications() {
        return this._proxy.notifications;
    }
    /**
     * Provide a user-friendly representation
     *
     * @returns Object
     */
    toJSON() {
        return {
            sid: this.sid,
            accountSid: this.accountSid,
            friendlyName: this.friendlyName,
            dateCreated: this.dateCreated,
            dateUpdated: this.dateUpdated,
            apnCredentialSid: this.apnCredentialSid,
            gcmCredentialSid: this.gcmCredentialSid,
            fcmCredentialSid: this.fcmCredentialSid,
            messagingServiceSid: this.messagingServiceSid,
            facebookMessengerPageId: this.facebookMessengerPageId,
            defaultApnNotificationProtocolVersion: this.defaultApnNotificationProtocolVersion,
            defaultGcmNotificationProtocolVersion: this.defaultGcmNotificationProtocolVersion,
            defaultFcmNotificationProtocolVersion: this.defaultFcmNotificationProtocolVersion,
            logEnabled: this.logEnabled,
            url: this.url,
            links: this.links,
            alexaSkillId: this.alexaSkillId,
            defaultAlexaNotificationProtocolVersion: this.defaultAlexaNotificationProtocolVersion,
            deliveryCallbackUrl: this.deliveryCallbackUrl,
            deliveryCallbackEnabled: this.deliveryCallbackEnabled,
        };
    }
    [util_1.inspect.custom](_depth, options) {
        return (0, util_1.inspect)(this.toJSON(), options);
    }
}
exports.ServiceInstance = ServiceInstance;
function ServiceListInstance(version) {
    const instance = ((sid) => instance.get(sid));
    instance.get = function get(sid) {
        return new ServiceContextImpl(version, sid);
    };
    instance._version = version;
    instance._solution = {};
    instance._uri = `/Services`;
    instance.create = function create(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["apnCredentialSid"] !== undefined)
            data["ApnCredentialSid"] = params["apnCredentialSid"];
        if (params["gcmCredentialSid"] !== undefined)
            data["GcmCredentialSid"] = params["gcmCredentialSid"];
        if (params["messagingServiceSid"] !== undefined)
            data["MessagingServiceSid"] = params["messagingServiceSid"];
        if (params["facebookMessengerPageId"] !== undefined)
            data["FacebookMessengerPageId"] = params["facebookMessengerPageId"];
        if (params["defaultApnNotificationProtocolVersion"] !== undefined)
            data["DefaultApnNotificationProtocolVersion"] =
                params["defaultApnNotificationProtocolVersion"];
        if (params["defaultGcmNotificationProtocolVersion"] !== undefined)
            data["DefaultGcmNotificationProtocolVersion"] =
                params["defaultGcmNotificationProtocolVersion"];
        if (params["fcmCredentialSid"] !== undefined)
            data["FcmCredentialSid"] = params["fcmCredentialSid"];
        if (params["defaultFcmNotificationProtocolVersion"] !== undefined)
            data["DefaultFcmNotificationProtocolVersion"] =
                params["defaultFcmNotificationProtocolVersion"];
        if (params["logEnabled"] !== undefined)
            data["LogEnabled"] = serialize.bool(params["logEnabled"]);
        if (params["alexaSkillId"] !== undefined)
            data["AlexaSkillId"] = params["alexaSkillId"];
        if (params["defaultAlexaNotificationProtocolVersion"] !== undefined)
            data["DefaultAlexaNotificationProtocolVersion"] =
                params["defaultAlexaNotificationProtocolVersion"];
        if (params["deliveryCallbackUrl"] !== undefined)
            data["DeliveryCallbackUrl"] = params["deliveryCallbackUrl"];
        if (params["deliveryCallbackEnabled"] !== undefined)
            data["DeliveryCallbackEnabled"] = serialize.bool(params["deliveryCallbackEnabled"]);
        const headers = {};
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        headers["Accept"] = "application/json";
        let operationVersion = version, operationPromise = operationVersion.create({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        });
        operationPromise = operationPromise.then((payload) => new ServiceInstance(operationVersion, payload));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.createWithHttpInfo = function createWithHttpInfo(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["apnCredentialSid"] !== undefined)
            data["ApnCredentialSid"] = params["apnCredentialSid"];
        if (params["gcmCredentialSid"] !== undefined)
            data["GcmCredentialSid"] = params["gcmCredentialSid"];
        if (params["messagingServiceSid"] !== undefined)
            data["MessagingServiceSid"] = params["messagingServiceSid"];
        if (params["facebookMessengerPageId"] !== undefined)
            data["FacebookMessengerPageId"] = params["facebookMessengerPageId"];
        if (params["defaultApnNotificationProtocolVersion"] !== undefined)
            data["DefaultApnNotificationProtocolVersion"] =
                params["defaultApnNotificationProtocolVersion"];
        if (params["defaultGcmNotificationProtocolVersion"] !== undefined)
            data["DefaultGcmNotificationProtocolVersion"] =
                params["defaultGcmNotificationProtocolVersion"];
        if (params["fcmCredentialSid"] !== undefined)
            data["FcmCredentialSid"] = params["fcmCredentialSid"];
        if (params["defaultFcmNotificationProtocolVersion"] !== undefined)
            data["DefaultFcmNotificationProtocolVersion"] =
                params["defaultFcmNotificationProtocolVersion"];
        if (params["logEnabled"] !== undefined)
            data["LogEnabled"] = serialize.bool(params["logEnabled"]);
        if (params["alexaSkillId"] !== undefined)
            data["AlexaSkillId"] = params["alexaSkillId"];
        if (params["defaultAlexaNotificationProtocolVersion"] !== undefined)
            data["DefaultAlexaNotificationProtocolVersion"] =
                params["defaultAlexaNotificationProtocolVersion"];
        if (params["deliveryCallbackUrl"] !== undefined)
            data["DeliveryCallbackUrl"] = params["deliveryCallbackUrl"];
        if (params["deliveryCallbackEnabled"] !== undefined)
            data["DeliveryCallbackEnabled"] = serialize.bool(params["deliveryCallbackEnabled"]);
        const headers = {};
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        headers["Accept"] = "application/json";
        let operationVersion = version;
        // CREATE, FETCH, UPDATE operations
        let operationPromise = operationVersion
            .createWithResponseInfo({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        })
            .then((response) => ({
            ...response,
            body: new ServiceInstance(operationVersion, response.body),
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.page = function page(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["pageSize"] !== undefined)
            data["PageSize"] = params["pageSize"];
        if (params.pageNumber !== undefined)
            data["Page"] = params.pageNumber;
        if (params.pageToken !== undefined)
            data["PageToken"] = params.pageToken;
        const headers = {};
        headers["Accept"] = "application/json";
        let operationVersion = version, operationPromise = operationVersion.page({
            uri: instance._uri,
            method: "get",
            params: data,
            headers,
        });
        operationPromise = operationPromise.then((payload) => new ServicePage(operationVersion, payload, instance._solution));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.each = instance._version.each;
    instance.list = instance._version.list;
    instance.getPage = function getPage(targetUrl, callback) {
        const operationPromise = instance._version._domain.twilio.request({
            method: "get",
            uri: targetUrl,
        });
        let pagePromise = operationPromise.then((payload) => new ServicePage(instance._version, payload, instance._solution));
        pagePromise = instance._version.setPromiseCallback(pagePromise, callback);
        return pagePromise;
    };
    instance.pageWithHttpInfo = function pageWithHttpInfo(params, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        if (params["friendlyName"] !== undefined)
            data["FriendlyName"] = params["friendlyName"];
        if (params["pageSize"] !== undefined)
            data["PageSize"] = params["pageSize"];
        if (params.pageNumber !== undefined)
            data["Page"] = params.pageNumber;
        if (params.pageToken !== undefined)
            data["PageToken"] = params.pageToken;
        const headers = {};
        headers["Accept"] = "application/json";
        let operationVersion = version;
        // For page operations, use page() directly as it already returns { statusCode, body, headers }
        // IMPORTANT: Pass full response to Page constructor, not response.body
        let operationPromise = operationVersion
            .page({ uri: instance._uri, method: "get", params: data, headers })
            .then((response) => ({
            statusCode: response.statusCode,
            headers: response.headers,
            body: new ServicePage(operationVersion, response, instance._solution),
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.each = instance._version.each;
    instance.eachWithHttpInfo = instance._version.eachWithHttpInfo;
    instance.list = instance._version.list;
    instance.listWithHttpInfo = instance._version.listWithHttpInfo;
    instance.getPageWithHttpInfo = function getPageWithHttpInfo(targetUrl, callback) {
        // Use request() directly as it already returns { statusCode, body, headers }
        const operationPromise = instance._version._domain.twilio.request({
            method: "get",
            uri: targetUrl,
        });
        let pagePromise = operationPromise.then((response) => ({
            statusCode: response.statusCode,
            headers: response.headers,
            body: new ServicePage(instance._version, response, instance._solution),
        }));
        pagePromise = instance._version.setPromiseCallback(pagePromise, callback);
        return pagePromise;
    };
    instance.toJSON = function toJSON() {
        return instance._solution;
    };
    instance[util_1.inspect.custom] = function inspectImpl(_depth, options) {
        return (0, util_1.inspect)(instance.toJSON(), options);
    };
    return instance;
}
class ServicePage extends Page_1.default {
    /**
     * Initialize the ServicePage
     *
     * @param version - Version of the resource
     * @param response - Response from the API
     * @param solution - Path solution
     */
    constructor(version, response, solution) {
        super(version, response, solution);
    }
    /**
     * Build an instance of ServiceInstance
     *
     * @param payload - Payload response from the API
     */
    getInstance(payload) {
        return new ServiceInstance(this._version, payload);
    }
    [util_1.inspect.custom](depth, options) {
        return (0, util_1.inspect)(this.toJSON(), options);
    }
}
exports.ServicePage = ServicePage;
